<a [routerLink]="['/prime']" class="no-prime-toast--link" *ngIf="primeConfig && !disabledPrime">

  <div class="no-prime-toast center" *ngIf="isPrime && primeSubscription?.total_saved < 4000"
    [ngStyle]="{'color': primeConfig.primary_color, 'border-color': primeConfig.primary_dark_color, 'background-color': primeConfig.secondary_color}">
    <img [src]="primeConfig.feature_landing_subscribe.icon_url_web" alt="farmatodo-prime">
    <span>Empieza a ahorrar</span>
  </div>

  <div class="no-prime-toast" *ngIf="!this.hasSessionValid || (!isPrime && primeSubscription?.savingCustomerNoPrime < 4000)"
    [ngStyle]="{'color': primeConfig.primary_color, 'border-color': primeConfig.primary_dark_color, 'background-color': primeConfig.secondary_color}">
    <img [src]="primeConfig.feature_landing_subscribe.icon_url_web" alt="farmatodo-prime">
    <span>Empieza a ahorrar</span>
  </div>

  <div class="no-prime-toast" *ngIf="!isPrime && primeSubscription?.savingCustomerNoPrime >= 4000"
    [ngStyle]="{'color': primeConfig.primary_color, 'border-color': primeConfig.primary_dark_color, 'background-color': primeConfig.secondary_color}">
    <div class="u-bold">
      <p>
        Con
        <img
          class="no-prime-toast__logo-prime"
          [src]="primeConfig.feature_prime_sticker.icon_url_web"
          alt="farmatodo-prime"
        />
        llevarias ahorrado:
      </p>
    </div>
    <div class="value" [ngStyle]="{ 'color': primeConfig?.primary_dark_color }">
      <span class="value__price ">
        {{primeSubscription?.savingCustomerNoPrime | multiCountryCurrency}}
      </span>
      <div routerLink="/prime" class="value__want-to-save"
        [ngStyle]="{'background-color': primeConfig?.accent_color , 'color':primeConfig?.primary_dark_color}">
        <strong>
          {{primeConfig.feature_cart_not_prime_item.button_text}}
        </strong>
        <img class="mx-1" src="assets/svg/arrow.svg" alt="Quiero ahorrar">
      </div>
    </div>
  </div>
  <div class="no-prime-toast" *ngIf="isPrime && primeSubscription?.total_saved >= 4000"
    [ngStyle]="{'color': primeConfig.primary_color, 'border-color': primeConfig.primary_dark_color, 'background-color': primeConfig.secondary_color}">
    <div class="u-bold">
      <p>
        Por ser
        <img
          class="no-prime-toast__logo-prime"
          [src]="primeConfig.feature_prime_sticker.icon_url_web"
          alt="farmatodo-prime"
        />
        has ahorrado:
      </p>
    </div>
    <div class="value justify-content-center" [ngStyle]="{ 'color': primeConfig?.primary_dark_color }">
      <span class="value__price ">
        {{primeSubscription?.total_saved | multiCountryCurrency}}
      </span>
    </div>
  </div>
</a>